import React, { useState, useEffect } from "react";
import { cloneDeep } from "lodash";

import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import TabsField from "components/Tab";

import { ReactComponent as WirelessIcon } from "assets/images/icons/icn_dashboard_wireless.svg";

import { PMF_MAP } from "pages/System/RealmSetting/components/Wireless/SSID/const";

import SettingsDrawer from "./settings";
import ClientsDrawer from "./clients";

const SSIDDrawer = ({
  isUnityPro,
  setAlertInfo,
  wirelessData,
  setWirelessData,
  onUpdateBlockerData,
  bandOptions,
  selectedRowData,
  securityTypeAssembleList,
  securityTypeConfig,
  originalRowData,
  setOriginalRowData,
  clientsData,
  setClientsData,
  siteId,
  orgId,
  entId,
  hasManageOrg,
  getWirelessSSID,
  setDrawerOpen,
  isValidInputStyles,
  showEditGeneral,
  radiusProfileOptions,
  wirelessScheduleOptions,
  macFilterOptions,
  ipFilterOptions,
  captivePortalOptions,
  bandCount,
  setBandCount,
  onCreateNewProfile,
}) => {
  const theme = useTheme();
  const [tabValue, setTabValue] = useState("settings");
  const [formData, setFormData] = useState(cloneDeep(selectedRowData));

  const tabData = [
    {
      name: "Settings",
      value: "settings",
      disabled: null,
      icon: null,
    },
    {
      name: "Clients",
      value: "clients",
      disabled: null,
      icon: null,
    },
  ];

  const getBandColor = band => {
    const bandValue = String(band);
    if (bandValue === '2') {
      return theme.palette.primary.orange; // 2.4GHz
    } else if (bandValue === '5') {
      return theme.palette.primary.greenPrimary; // 5GHz
    } else if (bandValue === '6') {
      return theme.palette.primary.main; // 6GHz
    }
    return theme.palette.primary.main; // Default value
  }

  useEffect(() => {
    if (!selectedRowData) return;

    const wpaMode = securityTypeConfig?.[selectedRowData?.security]?.wpaMode?.display ?? '';
    const newFormData = {
      ...selectedRowData,
      wpaMode,
      pmfState: PMF_MAP[wpaMode] ?? 'Disable',
    };
    setFormData(newFormData);
    setOriginalRowData(newFormData);
    setTabValue("settings");
  }, [selectedRowData]);

  return (
    <>
      <Box
        sx={{
          paddingLeft: "25px",
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        {formData && (
          <>
            <WirelessIcon />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              {formData?.ssid && (
                <span
                  style={{
                    fontWeight: theme.typography.customFontWeight[3],
                    fontSize: theme.typography.customFontSize[5],
                    color: theme.palette.primary.greyPrimary,
                  }}
                >
                  {formData.ssid}
                </span>
              )}
              {formData?.band?.length > 0 ? (
                <Box sx={{ display: "flex", gap: 1 }}>
                  {formData?.band.map((band, index) => {
                    const bandColor = getBandColor(band);
                    return (
                      <Box
                        key={index}
                        sx={{
                          color: bandColor,
                          border: `1.5px solid ${bandColor}`,
                          padding: "4px 12px",
                          minWidth: "65px",
                          height: "27px",
                          borderRadius: theme.shape.customBorderRadius[7],
                          fontSize: theme.typography.customFontSize[0],
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                        }}
                      >
                        {bandOptions[band]}GHz
                      </Box>
                    )
                  })}
                </Box>
              ) : (
                <Box>-</Box>
              )}
            </Box>
          </>
        )}
      </Box>

      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginTop: 2,
        }}
      >
        <TabsField
          tabsStyles={{
            "& .MuiButtonBase-root": {
              margin: "0 20px",
            },
          }}
          tabVal={tabValue}
          handleTabsChange={(e, newValue) => {
            setTabValue(newValue);
          }}
          tabData={tabData}
        />
      </Box>

      <Box sx={{ width: "100%" }}>
        {tabValue === "settings" && (
          <SettingsDrawer
            isUnityPro={isUnityPro}
            setAlertInfo={setAlertInfo}
            wirelessData={wirelessData}
            setWirelessData={setWirelessData}
            onUpdateBlockerData={onUpdateBlockerData}
            bandOptions={bandOptions}
            formData={formData}
            setFormData={setFormData}
            securityTypeAssembleList={securityTypeAssembleList}
            securityTypeConfig={securityTypeConfig}
            originalRowData={originalRowData}
            siteId={siteId}
            orgId={orgId}
            entId={entId}
            hasManageOrg={hasManageOrg}
            getWirelessSSID={getWirelessSSID}
            setDrawerOpen={setDrawerOpen}
            isValidInputStyles={isValidInputStyles}
            showEditGeneral={showEditGeneral}
            radiusProfileOptions={radiusProfileOptions}
            wirelessScheduleOptions={wirelessScheduleOptions}
            macFilterOptions={macFilterOptions}
            ipFilterOptions={ipFilterOptions}
            captivePortalOptions={captivePortalOptions}
            bandCount={bandCount}
            setBandCount={setBandCount}
            onCreateNewProfile={onCreateNewProfile}
          />
        )}
        {tabValue === "clients" && (
          <ClientsDrawer
            clientsData={clientsData}
            setClientsData={setClientsData}
            formData={formData}
            siteId={siteId}
            orgId={orgId}
            entId={entId}
            hasManageOrg={hasManageOrg}
            getWirelessSSID={getWirelessSSID}
          />
        )}
      </Box>
    </>
  );
};
export default SSIDDrawer;
